import { withStyles } from '@material-ui/core/styles'
import Popup from 'Components/Popup'
import React, { useState } from 'react'
import { useParams } from 'react-router-dom'
import { createCampaignClientCodes } from '../../../../gql/createCampaignClientCodes'
import styles from '../styles'
import useGetActivePopupInfo from './useGetActivePopupInfo'

const ClientCodeUploadPopup = ({
  onClose,
  isOpen,
  setCodesTable: setLoadedCodesTable,
  isCodesUploading,
  setIsCodesUploading,
  onRefetch,
  mapCodesTable,
  setShowCodesExplanationPage,
}) => {
  // eslint-disable-next-line no-unused-vars
  const [file, setFile] = useState(null)
  const [fileError, setFileError] = useState(null)
  const [warning, setWarning] = useState(null)
  const [codesTable, setCodesTable] = useState(null)
  const [trackingType, setTrackingType] = useState(null)
  const { campaignId } = useParams()

  const onCloseHandler = () => {
    setTrackingType(null)
    setFileError(null)
    setWarning(null)
    setCodesTable(null)
    onClose()
  }

  const onConfirm = async () => {
    setIsCodesUploading(true)
    try {
      const response = await createCampaignClientCodes({
        trackingType: trackingType,
        campaignId: campaignId,
        clientCodes: codesTable,
      })
      const result = await response.json()
      const codes = result.data.createCampaignClientCodes.clientCodes
      const newTrackingType = result.data.createCampaignClientCodes.trackingType
      mapCodesTable(codes, newTrackingType)
      onRefetch({
        campaignId: campaignId,
      })
    } catch (e) {
      // eslint-disable-next-line no-console
      console.error({ e })
    } finally {
      setFileError(null)
      setWarning(null)
      setFile(null)
      setIsCodesUploading(false)
      onClose()
    }
  }

  const { title, body: Body, footer: Footer } = useGetActivePopupInfo({
    trackingType,
    fileError,
    codesTable,
    setTrackingType,
    onConfirm,
    onCloseHandler,
    setCodesTable,
    setCriticalError: setFileError,
    setWarning,
    setFile,
    error: fileError,
    warning,
    isCodesUploading,
    setShowCodesExplanationPage,
  })

  if (!isOpen) {
    return null
  }

  return (
    <Popup
      title={title}
      onCancel={onCloseHandler}
      body={Body}
      footer={Footer}
      showCross
      canBeClose={!isCodesUploading}
      showBack={trackingType ? true : false}
      backHandler={() => {
        setTrackingType(null)
      }}
    />
  )
}

export default withStyles(styles)(ClientCodeUploadPopup)
